// src/api/contactApi.js
import api from "../configs/axiosConfig";

// POST /contact  (create new message to admin)
export async function sendContactMessage(userId, data) {
  const response = await api.post(`/contact/sent_contact_message/${userId}`, data);
  return response.data;
}

// GET /contact  (list user's contact messages)
export async function getMyContacts(userId) {
  const response = await api.get(`/contact/get_contact_message/${userId}`);
  return response.data;
}
